import { TableHeadDataProps } from '../../components/Table/TableHead';

export const providersTableHeadData: TableHeadDataProps[] = [
  { id: 0, title: '' },
  { id: 1, title: 'Name' },
  { id: 2, title: 'E-mail' },
  { id: 3, title: 'Phone' },
  { id: 4, title: 'Speciality' },
  { id: 5, title: 'About' },
  { id: 6, title: 'Address' },
  { id: 7, title: 'Actions' },
];
